import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingInversoresComponent } from './landing-inversores.component';

/**
 * Ruta interna de la feature. El proyecto anfitrión decide bajo qué path la monta,
 * normalmente vía lazy loading:
 *
 *   {
 *     path: 'landing-inversores',
 *     loadChildren: () =>
 *       import('./landing-inversores/landing-inversores.module')
 *         .then(m => m.LandingInversoresModule)
 *   }
 */
const routes: Routes = [
  {
    path: '',
    component: LandingInversoresComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingInversoresRoutingModule {}
